// gql tag to add to query to get syntax highlighting in vscode
export default function gqlTag(gqlQuery, ...substitutions) {
  return String.raw(gqlQuery, ...substitutions);
}
